import type {
  WorkbookDefinition,
  WorkbookOutput,
  WorkbookValidationResult,
} from '@erp/shared-types';
import { outputSheetIds } from '@erp/workbooks';
import type { WorkbookRunResults } from './workbookRunResults';

/** An error-severity Validation that failed on a Worksheet an Output reads. */
export interface OutputValidationFailure {
  sheetId: string;
  sheetName: string;
  check: WorkbookValidationResult;
}

/**
 * The error-severity Validations that failed in the Current Results of the
 * Worksheets `output` reads, as each Run checked them: while there are any,
 * the Output failed validation and its download asks first.
 */
export function outputValidationFailures(
  definition: WorkbookDefinition,
  output: WorkbookOutput,
  results: WorkbookRunResults,
): OutputValidationFailure[] {
  return outputSheetIds(definition, output).flatMap((sheetId) => {
    const { result, current } = results.sheet(sheetId);
    if (!current) return [];
    const sheetName =
      definition.sheets.find((sheet) => sheet.id === sheetId)?.name ?? '';
    return (result?.validations ?? [])
      .filter(
        (check) =>
          check.validation.severity === 'error' && check.failedRowCount > 0,
      )
      .map((check) => ({ sheetId, sheetName, check }));
  });
}
